import { zYesno } from '@/utils';
import { zLookup } from '@/utils/zodHelper';
import { z } from 'zod';

export const UserSchema = z.object({
  id: z.number().optional(),
  email: z.string().email(),
  first_name: z.string(),
  last_name: z.string(),
  is_active: z.boolean().optional(),
  is_superuser: z.boolean().optional(),
  preferred_language: z.object({
    id: z.string(),
    label: z.string(),
  }),
  unit: zLookup(),
  managed_units: z.array(zLookup()),
  leader_functional_areas: z.array(zLookup()),
  groups: z.array(zLookup()).optional(),
});

export const UserSearchSchema = z.object({
  search: z.string().optional(),
  is_active: zYesno().optional(),
  is_superuser: zYesno().optional(),
});

export type UserSchemaType = z.infer<typeof UserSchema>;
